import { RouteObject } from 'react-router/dist/lib/context';
import { Dashboard } from './components';

export const dashboardRoutes: RouteObject[] = [
  {
    path: '',
    element: <Dashboard />,
  }
]
